function Divider () {
    return <hr className="hr-style"></hr>
}

export default Divider;